module.exports = __webpack_public_path__ + "img/payment-progress-loading.045142c.gif";